import { NavLink, RouteObject, useNavigate } from "react-router";

import { Button, ButtonStyle, checkTabIsActive, PageHeading, Tabs } from "@prequel/shared-components";

import SourceConnectionDetails from "./SourceConnectionDetails";
import SourceDetails from "./SourceDetails";
import SourceForm from "./SourceForm";
import SourcePage, { SourceDetailsPage, SourceEditPage } from "./SourcePage";
import SourcesCards from "./SourcesCards";

import Breadcrumbs from "@/components/Breadcrumbs";

const tabs = [
  <NavLink key="Summary" to="/sources" className={checkTabIsActive} end>
    Summary
  </NavLink>,
];

const SourcesListLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Sources">
          <Button text="Add Source" onClick={() => navigate("/sources/new")} type={ButtonStyle.SECONDARY} />
        </PageHeading>
        <Tabs tabs={tabs} />
        <SourcesCards />
      </div>
    </div>
  );
};

const SourceFormNewLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-lg px-7 py-4">
        <PageHeading title="Add Source" onGoBack={() => navigate("/sources")} breadcrumbs={<Breadcrumbs />} />
        <SourceForm />
      </div>
    </div>
  );
};

export const sourcesRoutes: RouteObject = {
  path: "sources",
  handle: {
    breadcrumb: () => ({ label: "Sources" }),
  },
  children: [
    {
      index: true,
      element: <SourcesListLayout />,
    },
    {
      path: "new",
      handle: {
        breadcrumb: () => ({ label: "Add Source" }),
      },
      element: <SourceFormNewLayout />,
    },
    {
      path: ":sourceID",
      handle: {
        breadcrumb: () => ({
          label: "Source Details",
          dynamic: true,
        }),
      },
      element: <SourcePage />,
      children: [
        {
          element: <SourceDetailsPage />,
          children: [
            {
              index: true,
              element: <SourceDetails />,
            },
            {
              path: "connection",
              element: <SourceConnectionDetails />,
            },
          ],
        },
        {
          path: "edit",
          handle: {
            breadcrumb: () => ({
              label: "Edit Source",
            }),
          },
          element: <SourceEditPage />,
        },
      ],
    },
  ],
};
